
jQuery(function() {



/**
 *  //ヘッダーメニュードロップダウンリスト
 */

//タブレットとPCでクリックイベントとホバーイベントを切り替える
if (_ua.Tablet) {
	menuClick();
} else {
	menuHover();
}

function menuHover(){
	jQuery('.menu-item').on('mouseenter', function(){

		let $target = jQuery('.sub-menu',this);
		jQuery($target).addClass('is-on');

	}).on('mouseleave', function(){

		let $target = jQuery('.sub-menu',this);
		jQuery($target).removeClass('is-on');

	});
}

function menuClick(){

	//親のa要素を停止
	jQuery('.menu-item-has-children > a').on('click',function(){
		return false;
	});

	//停止したa要素を複製
	jQuery('.header-nav .menu-item-has-children > a').each(function(){

		let $target = jQuery(this).next('.sub-menu'); //　子メニューのラッパーを選択
		let $itme = jQuery(this).clone(); //　親メニューのオブジェクトを複製
		let $href = $itme.attr('href'); // オブジェクトからurlを取得
		let $text = $itme.text(); // オブジェクトからメニューの文字列を取得

		//複製した親メニューを子メニューに挿入
		jQuery($target).prepend('<li><a href="' + $href + '">' + $text + '</a></li>');

	});

	//クリックイベントでメニュー開閉
	jQuery('.menu-item a').on('click', function(){

		let $target_this = jQuery(this);
		let $target_subMenu = jQuery(this).next();

		if ($target_subMenu.css('display') === 'none') {
			jQuery('.sub-menu').removeClass('is-on');
			$target_subMenu.addClass('is-on');
		} else {
			$target_subMenu.removeClass('is-on');
		}

	});

}



/**
 * フルスクリーンナビゲーション 実行
 */
{

	// let navBtn  = '#nav_btn';
	// let nav     = '.footer-nav';
	// let navBody = '.footer-nav__body,.menu > ul';
	// let fsn     = new fullScreenNavigation2(navBtn,nav,navBody);
	// let flag    = true;

	// //ナビゲーションの開閉をクリックイベントにバインド
	// jQuery(navBtn).on('click',function(){
	// 	if (flag) {
	// 		flag = false;
	// 		fsn._trigger2();
	// 		jQuery(nav).toggleClass('is-d-block');
	// 		setTimeout(function(){
	// 			flag = true;
	// 		},500);
	// 	} else {
	// 		return;
	// 	}
	// });

	//ウィンドウをリサイズすると、ナビゲーションとスクロールを初期設定に戻す
	// jQuery(window).on('resize',function(){
	// 	fsn._navgationInitialize2();
	// 	jQuery(nav).removeClass('is-d-block');
	// });

}



/**
 * topページでスライド実行
 */
{

	let slid = new sd_slideshow(7500);

	jQuery(window).on('load',function(){

		if(jQuery('body').hasClass('home')){

			//ローディングイメージ削除
			jQuery('.loading-image').remove();

			//スライドショウ実行
			slid.slideshow();

			//スライド高さセット実行
		 	slid.heightSet();

		}

	 });

	/**
	 * スライドショウ高さ再セット実行
	 */
	jQuery(window).on('resize',function(){


		if(jQuery('body').hasClass('home')){

			//timerID;
			var timer = false;

			if (timer !== false) {
				clearTimeout(timer);
			}

			timer = setTimeout(function() {
				slid.heightSet();
			}, 1000);

		}

	 });

};



/**
 * 可視領域に要素が出現した時にanimate.cssのclassを付与し、スクロールに対するインタラクションを実行させる。
 */
jQuery(window).on('touchstart scroll', function(){
	animateScroll();
	fadeIn('.go-to-top');
});



/**
 * ウィンドウ上部に戻る
 */
jQuery('.go-to-top').on('click',function(){
	jQuery('body, html').animate({ scrollTop: 0 }, 800, 'swing');
	return false;
});



/**
 * ページ内スムーズスクロール実行(a要素を指定する)
 */
smoothScroll('a[href^=#]');



/**
 * トップページ 事業紹介
 *　画像挿入
 */
function homeJigyo(targe, fileName){
	let img = '<img class="home-jigyo-img fluid_img" src="' + gVar.img_path + fileName + '" alt="" />';
	jQuery(targe).children('.widgettitle').after(img);
}
homeJigyo('.home-bh', 'home_banner_c_02.png');
homeJigyo('.home-jinzai', 'home_banner_c_01.png');
homeJigyo('.home-kokoku', 'home_banner_c_05.png');





});//jQuery end